export default "__VITE_ASSET__ai2KEOOX__"